module.exports = __webpack_public_path__ + "img/gerencia1.853143dc.jpg";